<template>
  <v-dialog v-model="show" max-width="500px">
    <form ref="eventDialogForm">
      <v-card>
        <v-card-title>
          <span class="headline">
            <span>Add</span>
            Slide
          </span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex sm12>
                <v-text-field autofocus v-model="name" label="Some Name"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="show = !show">Cancel</v-btn>
          <v-btn color="blue darken-1" @click.stop="save" text>Save</v-btn>
        </v-card-actions>
      </v-card>
    </form>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { arrayUnion, arrayRemove } from "vuex-easy-firestore";
import * as firebase from "firebase";
const uuidv4 = require("uuid/v4");

export default {
  data: () => ({
    name: ""
  }),
  props: {
    value: Boolean
  },
  methods: {
    ...mapActions("slides", ["insert", "set", "delete", "patch"]),
    ...mapActions("events", ["fetchById"]),
    async save() {
      try {
        //let eventRef = this.$db.collection("slides").doc(this.event.id);

        let data = {
          id: this.slide.id,
          slides: arrayUnion({
            name: this.name,
            uuid: uuidv4(),
            components: [
              {
                uuid: uuidv4(),
                type: "Text",
                align: "left",
                text: "sample text",
                x: 500,
                y: 500,
                backgroundColor: {
                  hexa: "#ffffffff"
                },
                foreGroundColor: {
                  hexa: "#000000ff"
                },
                width: "200px",
                height: "500px",
                align: "left",
                animationIn: "fadeIn",
                animationOut: "fadeOut"
              }
            ]
          })
        };
        console.log(data);
        await this.patch(data);
        //        await this.insert(data);

        this.show = !this.show;
      } catch (e) {
        console.log("cannot save the shit with arrayUnion");
        console.error(e);
      }
    }
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        if (!value) {
          this.name = "";
        }
        this.$emit("input", value);
      }
    },
    event() {
      const pageId = this.$route.params.eventid;
      if (!pageId) return null;

      return this.$store.state.events.data[pageId];
    },
    slide() {
      const slideid = this.$route.params.slideid;
      if (!slideid) return null;

      return this.$store.state.slides.data[slideid];
    }
  }
};
</script>